import storage from 'store';
import qs from 'qs';

const ACCESS_TOKEN = 'ACCESS_TOKEN';

export const downloadUrl = (url, params) => {
  const token = storage.get(ACCESS_TOKEN);
  params.token = token;
  const baseURL = process.env.VUE_APP_API_BASE_URL;
  const a = document.createElement('a');
  const uri = `${baseURL}${url}?${qs.stringify(params)}`;
  a.href = uri;
  a.click();
};
export function base64ToBlob(base64, fileType) {
  const typeHeader = `data:application/${fileType};base64,`; // 定义base64 头部文件类型
  const audioSrc = typeHeader + base64; // 拼接最终的base64
  const arr = audioSrc.split(',');
  const array = arr[0].match(/:(.*?);/);
  const mime = (array && array.length > 1 ? array[1] : type) || type;
  // 去掉url的头，并转化为byte
  const bytes = window.atob(arr[1]);
  // 处理异常,将ascii码小于0的转换为大于0
  const ab = new ArrayBuffer(bytes.length);
  // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
  const ia = new Uint8Array(ab);
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i);
  }
  return new Blob([ab], {
    type: mime,
  });
}

export function getToken() {
  return storage.get(ACCESS_TOKEN);
}
